import React from 'react';
import { Link } from 'react-router-dom';

import styles from '../SSoft_Header.module.css';
import { BiRightArrowAlt } from 'react-icons/bi';

const renderChildItem = (itm) => {
  let type = 'button';
  if (itm.url_extension) {
    type = 'external';
  }
  if (itm.url && itm.url !== '/') {
    type = 'internal';
  }
  return type;
};

export default function ItemMobile({ itm, closeMenu }) {
  let html;
  const selectedType = renderChildItem(itm);
  const style = [styles.menuTitleM, 'w-full', itm.children?.length > 0 && ' mr-2', itm.url && 'text-[#8C8C8C]'].join(' ');

  switch (selectedType) {
    case 'button':
      html = (
        <div className="pb-[20px]">
          <div className="font-bold">{itm.title}</div>
        </div>
      );
      break;
    case 'internal':
      const isScrollTo = itm.url.includes('#');
      let handleClick = () => {
        closeMenu();
      };
      if (isScrollTo) {
        const elDestination = itm.url?.substring(itm.url.indexOf('#') + 1);
        if (elDestination) {
          handleClick = () => {
            closeMenu();
          };
        }
      }
      html = (
        <Link className="flex space-x-3 items-center group hover hover:bg-[#255262]/20 w-full py-2 rounded font-semibold" to={itm.url} type="button" onClick={handleClick}>
          <img
            src={itm?.article?.article_assets[0]?.asset?.asset_file || 'https://bzpublishassets.blob.core.windows.net/media/assets/Supersoft_Icon.svg'}
            alt=""
            className="w-[32px] h-[24px]"
          />
          <div className="text-black group-hover:text-[#255262]">{itm.title}</div>
          <BiRightArrowAlt className="ml-2 hidden group-hover:block" />
        </Link>
      );
      break;
    case 'external':
      html = (
        <a className={style} href={itm.url_extension} type="button" target="_blank" rel="noreferrer">
          <div className="">
            <div className="mr-[12px] pt-[4px]">
              <img
                src={itm?.article?.article_assets[0]?.asset?.asset_file || 'https://bzpublishassets.blob.core.windows.net/media/assets/Supersoft_Icon.svg'}
                alt=""
                className="w-[32px] h-[24px]"
              />
            </div>
            <div className="">{itm.title}</div>
          </div>
        </a>
      );
      break;
    default:
      break;
  }
  return html;
}
